<style lang="scss">
/* 样式保持不变 */
.monitorMachineMoldTable .el-progress-bar__outer {
  background: #606672;
}

.monitorMachineMoldTable .el-progress__text {
  color: #ffffff;
}

.monitorMachineMoldTable::before {
  z-index: inherit;
}

.monitorMachineMoldTable.el-table {
  background-color: transparent;
}

.monitorMachineMoldTable.el-table--border:after,
.monitorMachineMoldTable.el-table--group:after,
.monitorMachineMoldTable.el-table:before {
  background-color: transparent;
}

.monitorMachineMoldTable.el-table tr {
  background-color: transparent;
}

.monitorMachineMoldTable.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #33333a !important;
}

.monitorMachineMoldTable .el-table td.gutter,
.monitorMachineMoldTable.el-table th.gutter {
  background: transparent;
}

.monitorMachineMoldTable .el-table__body-wrapper::-webkit-scrollbar {
  width: 2px;
}

.monitorMachineMoldTable .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background-color: #419fff;
  border-radius: 2px;
}

.page-indicator {
  color: #c0c4cc;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.scroll-indicator {
  color: #c0c4cc;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
}
</style>

<style lang="scss" scoped="scoped">
.cell-class-name {
  border-bottom: 1px solid red !important;
}
</style>

<template>
  <div ref="container" style="overflow: auto;height: 100%;position: relative;padding: 20px;" :style="{ background: $attrs.monitorSetting.MONITOR_MODEL_MANAGE_STYLE_TEMPLATE == 'black' ? '#1D1D24' : '#000466' }">
    <div ref="titleBar" class="titleBar" style="display: flex;justify-content: space-between;align-items:center ;padding-bottom: 10px;">
      <!-- 标题 -->
      <div style="display: flex;align-items: center;">
        <span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
        <p style="font-size: 16px;line-height: 22px;color: #F4F4F4;">
          {{ $t('yujingxinxi') }}
        </p>
      </div>

      <!-- 翻页模式指示器 -->
      <div v-if="displayMode === 'page'" class="page-indicator">
        <span>{{ $t('dangqianye') }}: {{ currentPage }}/{{ totalPages }}</span>
        <el-button size="mini" @click="goPrevPage" :disabled="currentPage <= 1">{{ $t('shangyiye') }}</el-button>
        <el-button size="mini" @click="goNextPage" :disabled="currentPage >= totalPages">{{ $t('xiayiye') }}</el-button>
        <span style="margin-left: 16px;">{{ $t('zidongfanyesheng') }}: {{ countdown }}s</span>
      </div>

      <!-- 滚动模式指示器 -->
      <div v-if="displayMode === 'scroll'" class="scroll-indicator">
        <span>{{ $t('gundongmoshi') }} | {{ $t('zongtiaoshu') }}: {{ totalItems }}</span>
        <el-button size="mini" @click="toggleScroll" :type="isScrollPaused ? 'success' : 'warning'">
          {{ isScrollPaused ? $t('kaishigundong') : $t('zantinggundong') }}
        </el-button>
      </div>
    </div>

    <div :style="{ height: contentHeight + 'px' }">
      <el-table ref="table" class="monitorMachineMoldTable" :data="displayData" style="width: 100%" :max-height="contentHeight" :row-style="{ background: $attrs.monitorSetting.MONITOR_MODEL_MANAGE_STYLE_TEMPLATE == 'black' ? '#1d1d24' : '#000355', height: rowHeight + 'px' }" :cell-style="{ padding: 0 + 'px', borderColor: 'transparent', color: '#FFFFFF', 'font-size': '14px' }" :header-cell-style="{ background: $attrs.monitorSetting.MONITOR_MODEL_MANAGE_STYLE_TEMPLATE == 'black' ? '#33333A' : '#151599', color: '#C0C4CC', padding: '0px', height: '42px', borderColor: 'transparent', 'font-size': '14px' }" cell-class-name="cell-class-name">
        <el-table-column :label="$t('yewuleixing')">
          <template slot-scope="scope">
            <div style="font-size: 14px;font-weight: bold;">
              {{ scope.row.businessType || '-' }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('yewumingcheng')">
          <template slot-scope="scope">
            <div style="font-size: 14px;font-weight: bold;">
              {{ scope.row.businessName || '-' }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('yujingshijian')">
          <template slot-scope="scope">
            <div style="font-size: 14px;font-weight: bold;">
              {{ formatTime(scope.row.warningTime) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('yujingneirong')">
          <template slot-scope="scope">
            <div style="font-size: 14px;font-weight: bold;">
              {{ scope.row.warningContent || '-' }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('yujingdengji')">
          <template slot-scope="scope">
            <div :style="{ color: getWarningLevelColor(scope.row.warningLevel) }" style="font-size: 14px;font-weight: bold;">
              {{ getWarningLevelText(scope.row.warningLevel) }}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script type="text/javascript">
export default {
  name: 'web_customize_senmusi_monitor_warning_message_info',
  props: {
    displayMode: {
      type: String,
      default: 'page'
    },
    pageSize: {
      type: Number,
      default: 10
    },
    autoPageTime: {
      type: Number,
      default: 10
    },
    refreshInterval: {
      type: Number,
      default: 120
    }
  },
  watch: {
    '$attrs.orgId'(newValue, oldValue) {
      if (this.utils.isEqual(newValue, oldValue)) {
        return;
      }
      this.listData();
    },
    displayMode() {
      this.resetDisplayMode();
    },
    pageSize() {
      if (this.displayMode === 'page') {
        this.currentPage = 1;
        this.listData();
      }
    }
  },
  data() {
    return {
      // 通用数据
      contentHeight: 0,
      rowHeight: 0,
      allData: [],
      totalItems: 0,

      // 翻页模式数据
      currentPage: 1,
      totalPages: 1,
      countdown: 10,
      pageTimer: null,
      countdownTimer: null,

      // 滚动模式数据
      scrollTimer: null,
      isScrollPaused: false,
      scrollPosition: 0,
      scrollStep: 1,

      // 数据刷新定时器
      dataRefreshTimer: null,

      // 预警级别配置
      warningLevels: {
        '1': { text: 'yijiyujing', color: '#FF3A5E' },
        '2': { text: 'erjiyujing', color: '#FFC83A' },
        '3': { text: 'sanjiyujing', color: '#39F16D' }
      }
    };
  },
  computed: {
    displayData() {
      if (this.displayMode === 'page') {
        // 翻页模式：返回当前页数据
        const startIndex = (this.currentPage - 1) * this.pageSize;
        const endIndex = startIndex + this.pageSize;
        return this.allData.slice(startIndex, endIndex);
      } else {
        // 滚动模式：返回全部数据
        return this.allData;
      }
    }
  },
  created() {
    this.listData();
    this.setupTimers();
  },
  mounted() {
    this.resize();
    this.utils.event_hub.$on('RESIZE', () => {
      this.resize();
    });
  },
  beforeDestroy() {
    this.clearAllTimers();
  },
  methods: {
    // 数据获取方法
    async listData() {
      try {
        // 获取12小时内的预警数据
        const twelveHoursAgo = new Date(Date.now() - 12 * 60 * 60 * 1000);
        const params = {
          startTime: this.formatDateForAPI(twelveHoursAgo),
          endTime: this.formatDateForAPI(new Date()),
          pageNum: 1,
          pageSize: 10000 // 获取所有数据用于前端处理
        };

        let response = await this.http.get('/api/warning/messages', { params });

        if (response && response.data) {
          this.allData = response.data.rows || response.data.list || [];
          this.totalItems = this.allData.length;

          if (this.displayMode === 'page') {
            this.totalPages = Math.ceil(this.totalItems / this.pageSize) || 1;
            this.resetPageTimer();
          } else {
            // 使用 $nextTick 确保表格已经渲染
            this.$nextTick(() => {
              this.resetScrollTimer();
            });
          }
        }
      } catch (error) {
        console.error('获取预警数据失败:', error);
        // 使用模拟数据
        this.generateMockData();
      }
    },

    // 生成模拟数据
    generateMockData() {
      const businessTypes = ['shebeiyujing', 'shengchanyujing', 'zhiliangyujing', 'anquanyujing'];
      const businessNames = ['shebei001', 'shengchanxianA', 'zhiliangjiancha', 'anquanjiancha'];
      const warningContents = ['wenduchaoguo shedingzhi', 'yali yichang', 'zhuangtai yichang', 'shenduxian yujing', 'shengchanjindu luohou'];

      this.allData = [];
      const now = new Date();

      for (let i = 0; i < 35; i++) {
        const warningTime = new Date(now.getTime() - Math.random() * 12 * 60 * 60 * 1000);
        this.allData.push({
          id: i + 1,
          businessType: businessTypes[Math.floor(Math.random() * businessTypes.length)],
          businessName: businessNames[Math.floor(Math.random() * businessNames.length)],
          warningTime: warningTime.getTime(),
          warningContent: warningContents[Math.floor(Math.random() * warningContents.length)],
          warningLevel: Math.floor(Math.random() * 3) + 1 + ''
        });
      }

      this.totalItems = this.allData.length;
      this.totalPages = Math.ceil(this.totalItems / this.pageSize);
    },

    // 翻页模式方法
    goPrevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.resetPageTimer();
      }
    },

    goNextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.resetPageTimer();
      }
    },

    resetPageTimer() {
      // 清除现有定时器
      if (this.pageTimer) {
        clearInterval(this.pageTimer);
      }
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
      }

      // 重置倒计时
      this.countdown = this.autoPageTime;

      // 设置自动翻页定时器
      this.pageTimer = setInterval(() => {
        if (this.currentPage < this.totalPages) {
          this.currentPage++;
        } else {
          this.currentPage = 1; // 回到第一页
        }
        this.countdown = this.autoPageTime;
      }, this.autoPageTime * 1000);

      // 设置倒计时定时器
      this.countdownTimer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          this.countdown = this.autoPageTime;
        }
      }, 1000);
    },

    // 滚动模式方法 - 使用兼容性写法
    resetScrollTimer() {
      if (this.scrollTimer) {
        clearInterval(this.scrollTimer);
      }

      if (!this.isScrollPaused) {
        // 使用兼容性更好的写法替代可选链操作符
        const tableRef = this.$refs.table;
        const tableBody = tableRef && tableRef.bodyWrapper;

        if (tableBody) {
          this.scrollTimer = setInterval(() => {
            if (tableBody && !this.isScrollPaused) {
              tableBody.scrollTop += this.scrollStep;

              // 检查是否滚动到底部
              if (tableBody.scrollTop + tableBody.clientHeight >= tableBody.scrollHeight - 2) {
                // 滚动回顶部
                setTimeout(() => {
                  tableBody.scrollTop = 0;
                }, 1000);
              }
            }
          }, 50);
        } else {
          // 如果表格体不存在，延迟重试
          setTimeout(() => {
            this.resetScrollTimer();
          }, 100);
        }
      }
    },

    toggleScroll() {
      this.isScrollPaused = !this.isScrollPaused;
      if (!this.isScrollPaused) {
        this.resetScrollTimer();
      } else if (this.scrollTimer) {
        clearInterval(this.scrollTimer);
      }
    },

    // 通用方法
    resetDisplayMode() {
      this.clearAllTimers();
      this.currentPage = 1;
      this.isScrollPaused = false;

      if (this.displayMode === 'page') {
        this.resetPageTimer();
      } else {
        // 使用 $nextTick 确保表格已经渲染
        this.$nextTick(() => {
          this.resetScrollTimer();
        });
      }
    },

    setupTimers() {
      // 数据刷新定时器
      this.dataRefreshTimer = setInterval(() => {
        this.listData();
      }, this.refreshInterval * 1000);

      // 根据模式设置对应的定时器
      if (this.displayMode === 'page') {
        this.resetPageTimer();
      } else {
        // 使用 $nextTick 确保表格已经渲染
        this.$nextTick(() => {
          this.resetScrollTimer();
        });
      }
    },

    clearAllTimers() {
      if (this.pageTimer) {
        clearInterval(this.pageTimer);
      }
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
      }
      if (this.scrollTimer) {
        clearInterval(this.scrollTimer);
      }
      if (this.dataRefreshTimer) {
        clearInterval(this.dataRefreshTimer);
      }
    },

    // 工具方法
    formatTime(timestamp) {
      if (!timestamp) return '-';
      const date = new Date(timestamp);
      return (
        date.getFullYear() +
        '-' +
        (date.getMonth() + 1).toString().padStart(2, '0') +
        '-' +
        date
          .getDate()
          .toString()
          .padStart(2, '0') +
        ' ' +
        date
          .getHours()
          .toString()
          .padStart(2, '0') +
        ':' +
        date
          .getMinutes()
          .toString()
          .padStart(2, '0')
      );
    },

    formatDateForAPI(date) {
      return (
        date.getFullYear() +
        '-' +
        (date.getMonth() + 1).toString().padStart(2, '0') +
        '-' +
        date
          .getDate()
          .toString()
          .padStart(2, '0') +
        ' ' +
        date
          .getHours()
          .toString()
          .padStart(2, '0') +
        ':' +
        date
          .getMinutes()
          .toString()
          .padStart(2, '0') +
        ':' +
        date
          .getSeconds()
          .toString()
          .padStart(2, '0')
      );
    },

    getWarningLevelColor(level) {
      const levelConfig = this.warningLevels[level];
      return levelConfig ? levelConfig.color : '#C0C4CC';
    },

    getWarningLevelText(level) {
      const levelConfig = this.warningLevels[level];
      return this.$t(levelConfig ? levelConfig.text : 'weizhi');
    },

    resize() {
      setTimeout(() => {
        if (!this.$refs.titleBar || !this.$refs.container) {
          return;
        }

        // 计算内容高度
        this.contentHeight = this.$refs.container.offsetHeight - this.$refs.titleBar.offsetHeight - 20 - 20;

        // 修改行高计算，使其显示10条数据
        // 表头高度42px，剩余高度平均分配给10行数据
        const availableHeight = this.contentHeight - 42; // 减去表头高度
        this.rowHeight = availableHeight / 10; // 平均分配给10行

        console.log('表格高度调整:', {
          containerHeight: this.$refs.container.offsetHeight,
          titleBarHeight: this.$refs.titleBar.offsetHeight,
          contentHeight: this.contentHeight,
          rowHeight: this.rowHeight,
          displayRows: 10
        });
      }, 800);
    }
  }
};
</script>
